// CUR-168: Compliance audit shared helpers. Pure functions over the audit
// contract; the underlying constants (accepted-file set, playbook) live in
// ../../constants/compliance-audit.
import { COMPLIANCE_AUDIT_ACCEPTED_FILE_EXTENSIONS } from '../../constants/compliance-audit';

/** True if `name`'s extension is in the accepted set. Shared by client + server. */
export function isAcceptedComplianceAuditFile(name: string): boolean {
    const lower = name.toLowerCase();
    return COMPLIANCE_AUDIT_ACCEPTED_FILE_EXTENSIONS.some((ext) => lower.endsWith(ext));
}

/**
 * Render a 1-indexed sub-step order as a letter: 1 → "a", 2 → "b", … 26 → "z",
 * 27 → "aa" (bijective base-26). The playbook prose refers to sub-steps this
 * way ("1a", "5c"), so labels stay consistent with the descriptions.
 */
export function complianceAuditSubStepOrderLetter(order: number): string {
    let n = order;
    let label = '';
    while (n > 0) {
        const rem = (n - 1) % 26;
        label = String.fromCharCode(97 + rem) + label;
        n = Math.floor((n - 1) / 26);
    }
    return label || String(order);
}

/**
 * Human-facing sub-step label combining the numeric step order with the
 * lettered sub-step order, e.g. step 1 / sub-step order 2 → "1b". Single source
 * of truth shared by the client UI and the server activity log / agent prompts.
 */
export function formatComplianceAuditSubStepLabel(stepOrder: number, subStepOrder: number): string {
    return `${stepOrder}${complianceAuditSubStepOrderLetter(subStepOrder)}`;
}
